import { createApi } from '@/utils/server'
import request from '@/utils/server'
import { encrypt } from '@/utils/sm2'
import website from '@/config/website'
import CryptoJS from 'crypto-js'

export * from './agent'

/**
 * 登录 - 手机号加密登录
 * @param {string} phone - 手机号
 * @param {string} exhibitionId - 展会ID/租户ID（可选，默认从URL获取）
 */
export const loginByPhone = (phone, exhibitionId) => {
  const phoneValue = phone.value || phone
  const timestamp = Date.now()
  const encryptedPhone = encrypt(`${phoneValue}|${timestamp}`)
  // 如果没有传入exhibitionId，则从URL参数获取
  const tenantId = exhibitionId || new URLSearchParams(window.location.search).get('exhibitionId') || '000000'
  const params = new URLSearchParams()
  params.append('grant_type', 'phone')
  params.append('tenantId', tenantId)
  params.append('phone', encryptedPhone)
  params.append('timestamp', timestamp)
  params.append('scope', 'all')
  params.append('type', 'account')

  return request({
    url: '/blade-auth/oauth/token',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Basic ${CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(`${website.clientId}:${website.clientSecret}`))}`,
      'tenant-id': tenantId
    },
    meta: { isToken: false }
  })
}

/**
 * 获取应用配置
 * @author: BYM<yongming.bai@outlook.com>
 */
export const getAppConfig = (data) => createApi('/h5-config/info', 'GET', data)

/**
 * 小助手设定-详情
 * @author: BYM<yongming.bai@outlook.com>
 */
export const getAssistantSetting = (data) => createApi('/assistant-setting/getMySetting', 'GET', data)

/**
 * 小助手设定-保存
 * @author: BYM<yongming.bai@outlook.com>
 */
export const saveAssistantSetting = (data) => createApi('/assistant-setting/save', 'POST', data)

/**
 * 获取用户详情
 * @author: BYM<yongming.bai@outlook.com>
 */
export const getUserDetail = (data) => createApi('/blade-system/user/detail', 'GET', data)


/**
 * 为您推荐
 * @author: BYM<yongming.bai@outlook.com>
 * exhibitionId
 */
export const fetchRecommendation = (params) => createApi('/feed/random-match', 'GET', params)

/**
 * 会议详情
 * @author: BYM<yongming.bai@outlook.com>
 */
export const fetchMeetingDetail = (data) => createApi('/meeting/detail', 'GET', data)

/**
 * 展品详情
 * @author: BYM<yongming.bai@outlook.com>
 */
export const fetchExhibitDetail = (data) => createApi('/t-project/detail', 'GET', data)

/**
 * 展商详情
 * @author: BYM<yongming.bai@outlook.com>
 */
export const fetchExhibitorDetail = (data) => createApi('/exhibitor-main/detail', 'GET', data)

/**
 * 商机详情
 * @author: BYM<yongming.bai@outlook.com>
 */
// TODO 商机详情API待完善
export const fetchOpportunityDetail = (data) => createApi('/opportunity/detail', 'GET', data)

/**
 * AI推荐理由
 * @author: BYM<yongming.bai@outlook.com>
 */
export const fetchAiRecommendReason = (data) => createApi('/meeting-recommend/reason', 'GET', data)

/**
 * 展品列表
 * @author: BYM<yongming.bai@outlook.com>
 */
export const fetchExhibitList = (data) => createApi('/t-project/page', 'GET', data)
